var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86 19.947V1h4.123V12.58c.789-.644 2.701-2.019 4.035-2.37 1.666-.438 5.087-1.315 7.982.878 2.316 1.754 2.953 5.526 2.983 7.193V31h-4.211V20.737c.146-2.486-.667-7.456-5.088-7.456-4.42 0-5.643 4.445-5.701 6.667h3.596v3.685H4.999v-3.685h3.86z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 31v-3.333H16.58V31H4.999z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtr);
export default __webpack_public_path__ + "static/media/HTR.24785999e0e4c7a38b87448721000cc0.svg";
export { ForwardRef as ReactComponent };